import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Edit05 = function Edit05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11 4H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.2798 2 7.1198 2 8.8v8.4c0 1.6801 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 22 5.1198 22 6.8 22h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8801 20 17.2V13M8 16h1.6745c.4892 0 .7338 0 .964-.0553a2 2 0 0 0 .5781-.2394c.2018-.1237.3748-.2967.7207-.6426L21.5 5.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0l-9.5628 9.5627c-.3459.3459-.5188.5189-.6425.7207a2 2 0 0 0-.2395.5781C8 13.5917 8 13.8363 8 14.3255z"
    })
  }));
};
export default Edit05;